import { cpf } from 'cpf-cnpj-validator';

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = 'Esse campo não pode ficar vazio';
  }
  if (!values.firstName) {
    errors.firstName = 'Esse campo não pode ficar vazio';
  }
  if (!values.lastName) {
    errors.lastName = 'Esse campo não pode ficar vazio';
  }

  if (values.zipCode) {
    if (values.zipCode.trim().length < 8) {
      errors.zipCode = 'CEP Inválido';
    }
  }

  if (values.cpf) {
    const cpfIsValid = cpf.isValid(values.cpf);
    if (!cpfIsValid) {
      errors.cpf = 'Informe um CPF válido!';
    }
  }

  if (!values.cpf) {
    errors.cpf = 'Informe um CPF válido!';
  }

  return errors;
};

export default validate;
